import {observer} from 'mobx-react-lite'
import React from 'react'
import {useEffect, useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {CheckboxNew} from '@components/common/base/checkbox-new/checkbox-new'
import {Dialog} from '@components/common/base/dialog/dialog'
import {useLoggedInStore} from '@components/logged-in/logged-in-store'

const TwContentContainer = tw.div`
  font-normal
  text-14
  leading-5
`

const TwShowLaterBlock = tw.div`
  mt-12
`

export const timelineAutoPlanningPopupCtl: {
  open: () => void
  onClose?: () => void
  onAccept?: () => void
} = {
  open: (): void => void 0,
  onClose: (): void => void 0,
  onAccept: (): void => void 0
}

export const TimelineAutoPlanningPopup = observer(() => {
  const [loggedInState, loggedInStore] = useLoggedInStore()
  const [blockWarning, setBlockWarning] = useState(
    loggedInState?.blockGanttAutoPlanningWarning ?? false
  )
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    timelineAutoPlanningPopupCtl.open = () =>
      setTimeout(() => setVisible(true), 100)
  }, [])

  const onClosing = () => {
    setVisible(false)
    setBlockWarning(loggedInState.blockGanttAutoPlanningWarning ?? false)
  }

  const onClose = () => {
    onClosing()
    timelineAutoPlanningPopupCtl.onClose?.()
  }

  const onApply = () => {
    if (!visible) {
      return
    }

    if (blockWarning) {
      loggedInStore.setBlockGanttAutoPlanningWarning('true')
    }

    onClosing()
    timelineAutoPlanningPopupCtl.onAccept?.()
  }

  if (loggedInState?.blockGanttAutoPlanningWarning) {
    setTimeout(onApply)
    return null
  }

  if (!visible) {
    return null
  }

  return (
    <Dialog
      close={onClose}
      submit={onApply}
      title={Lang.msg.timeline.autoPlanningPopup.title}
      width={370}
    >
      <TwContentContainer style={{letterSpacing: '-0.2px'}}>
        {Lang.msg.timeline.autoPlanningPopup.content}
        <TwShowLaterBlock>
          <CheckboxNew
            value={blockWarning}
            onChange={() => setBlockWarning(x => !x)}
            label={Lang.msg.timeline.autoPlanningPopup.checkboxTitle}
            labelClassName="!text-grey"
          />
        </TwShowLaterBlock>
      </TwContentContainer>
    </Dialog>
  )
})
